import { Box, TableCell, TableSortLabel } from '@mui/material';
import { useCallback } from 'react';
import * as React from 'react';
import pxToRem from 'assets/theme/function/px-to-rem';
import colors from 'assets/theme/base/colors';

interface Props {
    sort?: string;
    setSort?: React.Dispatch<React.SetStateAction<string>>;
    cellId: number;
    name: string;
    value?: string | number | boolean;
    isSortable?: boolean;
}

export const TableCellSorting: React.FC<Props> = ({
    sort,
    setSort,
    cellId,
    name,
    value,
    isSortable,
}) => {
    const getSortType = useCallback(() => {
        if (sort === `-${name}`) return 'desc';
        if (sort === name) return 'asc';
        return undefined;
    }, [sort, name]);

    const toggleSort = () => {
        if (!setSort) return;

        const current = getSortType();
        if (current === 'asc') setSort(`-${name}`);
        else if (current === 'desc') setSort('');
        else setSort(name);
    };

    return (
        <TableCell key={cellId}>
            <Box display="flex" alignItems="center" justifyContent="center">
                {isSortable && (
                    <TableSortLabel
                        sx={{
                            color: colors.common.white,
                            '& svg': {
                                width: pxToRem(22),
                                height: pxToRem(22),
                            },
                        }}
                        active={!!getSortType()}
                        direction={getSortType() === 'desc' ? 'desc' : 'asc'}
                        onClick={toggleSort}
                    />
                )}
                {value}
            </Box>
        </TableCell>
    );
};
